import Vue from 'vue'
import Vuex from 'vuex'
import { auth } from './modules/auth'
import { alert } from './modules/alert'
import orders from './modules/orders'
import products from './modules/products'
import { acoDataModule } from './modules/acoData'
import profiles from './modules/profiles'
import promo from './modules/promo'
import setup from './modules/setup'
// might want to create our own user module to store user info like billing address email etc

Vue.use(Vuex)




const state = {

}
const mutations = {

}
const actions = {

}
export default new Vuex.Store({
  modules: {
    auth,
    alert,
    orders,
    products,
    profiles,
    acoData: acoDataModule,
    setup,
    promo
  },
  state,
  mutations,
  actions
})